import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'pc-sql-iaas-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'pc-sql-iaas-quickConfigDetails',
    default: undefined,
});

export const defaultVmDataDisk = atom({
    key: 'pc-sql-iaas-defaultVmDataDisk',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'pc-sql-iaas-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDiskOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isEnvDetailsLoading = atom({
    key: 'pc-sql-iaas-isEnvDetailsLoading',
    default: false,
});

export const isDataDiskLoaded = atom({
    key: 'pc-sql-iaas-isDataDiskLoaded',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'pc-sql-iaas-isConfigDiskFulfilled',
    default: false,
});

export const defaultOsDiskType = atom({
    key: 'pc-sql-iaas-defaultOsDiskType',
    default: undefined,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'pc-sql-iaas-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'pc-sql-iaas-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'pc-sql-iaas-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const isCostcenterValid = atom({
    key: 'pc-sql-iaas-isCostcenterValid',
    default: true,
});

export const sspSubmitOrder = atom({
    key: 'pc-sql-iaas-sspOrder',
    default: {
        // Application Section
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetail: null,
        environment: null,
        landingZoneDetails: null,
        region: 'Dallas Data Center',
        dtc: 'Dallas Data Center',
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appTier: null,
        appTierCode: null,
        businessCategory: null,
        dataClassification: null,

        // Resource Section
        clusterDetails: null,
        clusterName: null,
        clusterVlans: [],
        vlanDetails: null,
        vlanName: null,
        osType: 'Windows',
        osImage: null,
        osName: null,
        osDisplayName: null,
        cpu: null,
        memoryGiB: null,
        quantity: 1,
        maxDataDiskCount: 8,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        appShortName: null,
        gmsaServiceAcc: '',
        gmsaComputerGrp: '',
        timeZone: null,
        displayTimeZone: null,
        billingEntity: null,
        billingEntityDetails: null,

        // SQL Instance Section
        sqlVersion: null,
        serverCollation: null,
        serviceInstalled: [],
        expDBSize: null,
        databaseName: '',
        isManualDBName: false,

        // Access Management Section
        domain: null,
        adous: null,
        adousDetails: null,
        adGroup: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'pc-sql-iaas-costEstimateState',
    default: null,
});

export const isLoadingCostApiState = atom({
    key: 'pc-sql-iaas-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const showisExistADGrp = atom({
    key: 'pc-sql-iaas-showisExistADGrp',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'pc-sql-iaas-isAppShortNameExist',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'pc-sql-iaas-isAppShortNameValid',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'pc-sql-iaas-CurrentServerDetails',
    default: null,
});

export const isDBNameValid = atom({
    key: 'pc-sql-iaas-isDBNameValid',
    default: false,
});

export const isExpectedDbSizeValid = atom({
    key: 'pc-sql-iaas-isExpectedDbSizeValid',
    default: false,
});
